import React, { ReactNode, useEffect } from 'react'
import DynamicForm, { IDynamicFormElement, IFormElementsData, ISingleFormElementData } from './DynamicForm'
import TextFieldElement2 from '../Fields/TextFieldElement2'
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material'
import SelectFieldElement from '../Fields/SelectFieldElement'
import ImageUploader from '../Fields/ImageUploader'
import LocationSelectFieldElement from '../Fields/LocationSelectFieldElement'
import WarehouseSelectFieldElement from '../Fields/WarehouseSelectFieldElement' 
import CategorySelectFieldElement from '../Fields/CategorySelectFieldElement'
import SectionSelectFieldElement from '../Fields/SectionSelectFieldElement'
import ItemSelectFieldElement from '../Fields/ItemSelectFieldElement'
import UsersSelectFieldElement from '../Fields/UsersSelectFieldElement'
import DateAndTimeField from '../Fields/DateAndTimeField'
import DynamicSelect from '../Fields/DynamicSelect'
import BlockEditor from '../Fields/BlockEditor'
import DynamicSelectItemField from '../Fields/DynamicSelectItemField'
import DynamicModelSelect from '../Fields/DynamicModelSelect'
import DateField from '../Fields/DateField'
import GoogleMapsEmbeded from '../Fields/GoogleMapsEmbeded'
import SelectCountry from '../Fields/SelectCountry'
import AttachmentsField from '../Fields/AttachmentsField'

interface IProps {
    element: IDynamicFormElement,
    handleOnChange: (id: string, value: any) => void
}

interface IBaseFormElementProps {
    element: IDynamicFormElement,
    data: ISingleFormElementData,
    children: ReactNode
}

const BaseFormElement: React.FC<IBaseFormElementProps> = ({ children, ...props }) =>{

    const { element, data } = props

    return(
        <div className="dynamic-form-single-form-elemnt">
            <div className="content-of-dynamic-form-single-form-elemnt">
                <FormControl fullWidth={element.fullWidth}>
                    {children}
                    {data.displayHelperText && (
                        <FormHelperText error={data.helperTextType === "error" ? true : false}>
                            {data.helperText}
                        </FormHelperText>
                    )}
                </FormControl>
            </div>
        </div>
    )
}

export default function RenderFormElement(props: IProps) {

    const { element, handleOnChange } = props

    const data = DynamicForm.useReturnSingleFormElementData(element.id)

    switch(element.type){

        case "TextField":
            return <BaseFormElement element={element} data={data}><TextFieldElement2 {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "BlockEditor":
            // @ts-ignore
            return <BaseFormElement element={element} data={data}><BlockEditor {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "DateAndTime":
            return <BaseFormElement element={element} data={data}><DateAndTimeField {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "Date":
            return <BaseFormElement element={element} data={data}><DateField {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "Select":
            return <BaseFormElement element={element} data={data}><SelectFieldElement {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "DynamicSelect":
            return <BaseFormElement element={element} data={data}><DynamicSelect {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "DynamicModelSelect":
            return <BaseFormElement element={element} data={data}><DynamicModelSelect {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement> 

        case "ImageUploader":
            return <ImageUploader {...element} data={data} handleOnChange={handleOnChange} />

        case "SelectLocation":
            return <BaseFormElement element={element} data={data}><LocationSelectFieldElement {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "SelectWarehouse":
            return <BaseFormElement element={element} data={data}><WarehouseSelectFieldElement {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "SelectCategory":
            return <BaseFormElement element={element} data={data}><CategorySelectFieldElement {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "SelectSection":
            return <BaseFormElement element={element} data={data}><SectionSelectFieldElement {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "SelectItem":
            return <BaseFormElement element={element} data={data}><DynamicSelectItemField {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "SelectUser":
            return <BaseFormElement element={element} data={data}><UsersSelectFieldElement {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "GoogleMap":
            return <BaseFormElement element={element} data={data}><GoogleMapsEmbeded {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>
        
        case "SelectCountry":
            return <BaseFormElement element={element} data={data}><SelectCountry {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>

        case "Checkbox":
            return (
                <BaseFormElement element={element} data={data}>
                    <FormControlLabel control={<Checkbox checked={data.value} onChange={(e) => handleOnChange(element.id, e.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />} label={element.label} />
                </BaseFormElement>
            )

        case "Images":
            return <BaseFormElement element={element} data={data}><AttachmentsField {...element} data={data} handleOnChange={handleOnChange} /></BaseFormElement>


        default:
            return <></>
    }

}